<template>
  <div class="h-100 w-100" id="Cabinet">
    <!-- <div class="list w-100 h-100 p-l-10 p-r-10" v-if="!isEdit">
      <div class="d-flex list_content">
        <p class="m-t-20 fz-14">机柜名称</p>
        <el-input class="m-l-10 m-t-20"></el-input>
        <p class="m-t-20 fz-14">对象编号</p>
        <el-input class="m-l-10 m-t-20"></el-input>
      </div>
      <el-button class="w-100 m-t-20" type="primary" @click="editDevice">修改机柜模型</el-button>
    </div> -->
    <div
      class="Cabinet_top p-10"
      :style="{
        height: !isShowTags ? '' : 'calc(100% - 48px)',
      }"
    >
      <el-row>
        <el-col :span="4"><span class="fz-12">对象编号</span></el-col>
        <el-col :span="20"
          ><el-input
            class="w-100"
            clearable
            placeholder="对象编号"
            size="small"
            v-model="currentNodeName"
          ></el-input
        ></el-col>
      </el-row>
      <el-row class="m-t-10">
        <el-col :span="4"><span class="fz-12">机柜名称</span></el-col>
        <el-col :span="20"
          ><el-input
            class="w-100"
            clearable
            placeholder="机柜名称"
            size="small"
            v-model="cabinetName"
          ></el-input
        ></el-col>
      </el-row>
      <el-button
        class="w-100 m-t-10"
        v-if="showEdit && !isShowTags"
        type="primary"
        @click="editDevice"
        size="mini"
        >编辑机柜设备</el-button
      >
    </div>
    <div
      v-if="!isShowTags"
      class="Cabinet_bottom fz-14"
      :style="{
        height:
          showEdit && !isShowTags
            ? 'calc(100% - 180px)'
            : isShowTags
            ? 'calc(100% - 155px)'
            : 'calc(100% - 142px)',
      }"
    >
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="4"><span class="fz-12">机柜样式</span></el-col>
        <el-col :span="18">
          <el-input
            v-model="searchTypeKey"
            placeholder="名称搜索"
            clearable
            size="small"
          ></el-input>
        </el-col>
        <el-col :span="2">
          <el-tooltip effect="dark" content="搜索" placement="top">
            <el-button
              @click="search"
              type="primary"
              size="mini"
              class="iconfont icon-search"
            ></el-button>
          </el-tooltip>
        </el-col>
      </el-row>

      <div class="Cabinet_model">
        <el-row>
          <el-col :span="8" v-for="(item, index) in deviceList" :key="index">
            <div class="w-100 model-item p-10 cur-pointer">
              <div class="w-100 item-img">
                <img
                  class="w-100 h-100"
                  width="100%"
                  height="100%"
                  :src="`${currentEnv.VUE_APP_PLANT_SERVER}${item.thumbnails}`"
                  alt=""
                />
              </div>
              <div
                class="w-100 item-title tc ell"
                @click="
                  (e) => {
                    e.stopPropagation()
                  }
                "
              >
                <el-checkbox
                  v-model="item.select"
                  class="text-color-white d-flex flex-align-center flex-row-center m-t-5"
                  @change="selectChange(item)"
                  >{{ item.name }}</el-checkbox
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="card-footer w-100 m-t-10" v-if="!isShowTags">
      <el-row type="flex" align="middle" class="w-100">
        <el-col :span="9">
          <div
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-radio-group v-model="addTypeValue" class="d-flex flex-align-center">
              <el-radio size="small" :label="1">锚点位置</el-radio>
              <el-radio size="small" :label="2">按节点</el-radio>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="8" class="p-l-5 p-r-5">
          <el-select
            v-model="nodePositionValue"
            placeholder="中心"
            size="mini"
            popper-class="document_select-popper"
          >
            <el-option
              v-for="item in nodePostionProp"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" class="tr">
          <el-button type="primary" size="mini" @click="loadCabinetNode">新增</el-button></el-col
        >
      </el-row>
    </div>
    <div class="card-footer w-100 m-t-10" v-else>
      <el-row type="flex" align="middle" class="w-100">
        <el-col :span="12"> </el-col>
        <el-col :span="12" class="tr"
          ><el-button size="mini" @click="cancleModify">取消</el-button>
          <el-button type="primary" size="mini" @click="saveCabinetInfo">保存</el-button></el-col
        >
      </el-row>
    </div>
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import ApiMixinDocuments from '@/assets/js/api/documents'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import { isJSONObj, loadFbxModel, generateGUID, loadPrModel } from '../../../js/engineerSceneData'

const PlayerProgress = () => {
  return import('@/components/model/PlayerProgress')
}
export default {
  components: { PlayerProgress },
  props: ['player', 'isShowTags', 'currentNodeData'],
  mixins: [ApiMixinDocuments, ApiMixinDocumentList],
  data() {
    return {
      isJSONObj,
      nodePositionValue: 'YN',
      showLoadProgress: false,
      loadPercentage: 0,
      loadType: '',
      searchKey: '',
      currentNodeName: '', // 对象名称
      searchTypeKey: '', // 列表搜索
      showListData: true,
      deviceList: [],
      tableLoading: false,
      defaultFolderId: null, // 仪器的文件路径id
      templateAttrSetList: [],
      addTypeValue: 1, // 添加类型
      isEdit: true,
      searchValue: '',
      objectNumber: '',
      cabinetName: '',
      nodePostionProp: [
        {
          value: 'Z',
          label: '上方',
        },
        {
          value: 'ZN',
          label: '下方',
        },
        {
          value: 'YN',
          label: '前方',
        },
        {
          value: 'Y',
          label: '后方',
        },
        {
          value: 'XN',
          label: '左方',
        },
        {
          value: 'X',
          label: '右方',
        },
      ],
      defaultTagFolderId: '',
      tagDataList: [], // 标签列表
      currentCreateParams: {}, // 新增模型的参数
      propsNodeData: {},
      nodePosition: [],
      currentTagFile: {},
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    DevicesLibrariesFolder() {
      const path = _.find(this.systemParams, { parameterCode: 'DevicesLibrariesFolder' }) || {}
      return path.parameterValue || null
    },
    DevicesClassId() {
      const parameter = _.find(this.systemParams, { parameterCode: 'DevicesClass' }) || {}
      return parameter ? parameter.parameterValue : ''
    },
    showEdit() {
      return (
        isJSONObj(this.propsNodeData.code) &&
        JSON.parse(this.propsNodeData.code).type &&
        JSON.parse(this.propsNodeData.code).type === 'Cabinet'
      )
    },
  },
  watch: {
    currentNodeData: {
      handler(val) {
        this.propsNodeData = _.cloneDeep(val)
        if (this.isShowTags) {
          this.currentNodeName = val.name
          this.cabinetName =
            isJSONObj(val.code) && JSON.parse(val.code) ? JSON.parse(val.code).titleText : val.name
          _.forEach(this.deviceList, (item) => {
            if (isJSONObj(val.code) && item.id === JSON.parse(val.code).documentId) {
              item.select = true
            }
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    await this.getFolderClassId()
    // 获取属性模板
    await this.getAttributeTemplateList()
    await this.getTagFolderClassId()
    this.getModelTagList()
    // 获取机柜列表
    this.getDataList()
  },
  mounted() {
    this.propsNodeData = _.cloneDeep(this.currentNodeData)
  },
  methods: {
    // 编辑机柜编号、名称
    async saveCabinetInfo() {
      if (this.currentNodeData.nodePtr) {
        const titleNode = await this.player.Native.NodeProxy.findFirstNodeByName(
          this.currentNodeData.nodePtr,
          'Title_Top'
        )
        const titleNodeInfo = await this.player.Native.NodeProxy.getNodeInfo(titleNode)
        if (isJSONObj(this.currentNodeData.code) && isJSONObj(titleNodeInfo.code)) {
          const cabinetData = JSON.parse(this.currentNodeData.code)
          cabinetData.titleText = this.cabinetName
          await this.player.Native.NodeProxy.setNodeInfo(this.currentNodeData.nodePtr, {
            name: this.currentNodeName,
            code: JSON.stringify(cabinetData),
          })
          const titleData = JSON.parse(titleNodeInfo.code)
          const guid = generateGUID()
          const url = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${cabinetData.md5}/${guid}.png`
          const canvas = document.createElement('canvas')
          canvas.width = 500
          canvas.height = 50
          const ctx = canvas.getContext('2d')
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(0, 0, canvas.width, canvas.height)
          ctx.font = 'bold 28px arial'
          ctx.textAlign = 'center'
          ctx.fillStyle = '#ff0000'
          ctx.fillText(this.cabinetName, 250, 30)
          const imgUrl = canvas.toDataURL('image/png')
          canvas.remove()
          await this.player.Native.File.downloadFile(url, 'GET', imgUrl, {}, async (res) => {
            await this.player.Native.NodeProxy.setNodeInfo(titleNode, {
              code: JSON.stringify({
                type: 'CabinetTag',
                fileType: titleData.fileType,
                filePath: titleData.filePath,
                documentId: titleData.documentId,
                documentName: titleData.documentName,
                documentCode: titleData.documentCode,
                md5: titleData.md5,
                materialFileMd5: titleData.materialFileMd5,
                model: titleData.model,
                tagInfo: {
                  text: this.cabinetName,
                  id: guid,
                  file: `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${cabinetData.md5}/${guid}.png`,
                },
              }),
            })
            const childNode = await this.player.Native.NodeProxy.getNodeChildren(titleNode)
            const materialPtr = await this.player.Native.NodeProxy.getNodeMaterial(
              childNode[0].nodePtr
            )
            if (materialPtr) {
              const copyMaterial = await this.player.Native.NodeProxy.copyMaterial(materialPtr)
              await this.player.Native.NodeProxy.setNodeMaterial(childNode[0].nodePtr, copyMaterial)
              await this.player.Native.NodeProxy.setMaterialTexture(copyMaterial, url)
            }
            this.$emit('updateEditTree', titleNode)
          })
        }
      }
    },
    // 获取标签的文件路径id
    async getTagFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '标签',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '标签'
          })
          if (currentFolder) {
            this.defaultTagFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取标签列表
    async getModelTagList() {
      if (this.defaultTagFolderId) {
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: this.defaultTagFolderId,
          isRecursion: true,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
        }
        const res = await DocumentManagementService.advancedSearch(query)
        if (res && res.code === 0 && res.data) {
          this.tagDataList = res.data.items
        }
      }
    },
    // 加载模型
    async createNode(data) {
      if (_.isEmpty(data.documentDataList)) {
        this.$message.warning('请选择设备进行添加')
        return
      }
      this.currentCreateParams = _.cloneDeep(data)
      if (this.currentCreateParams.positionType === 'anchor') {
        this.nodePosition = await this.player.Native.Camera.getAnchorPos()
      } else if (this.currentCreateParams.positionType === 'faceCenter') {
        if (this.propsNodeData.item) {
          const calcData = await this.player.Native.ModelTree.calcItemAabbData(
            this.propsNodeData.item
          )
          this.nodePosition = Aabb.faceCenter(calcData.aabb, this.currentCreateParams.faceValue)
        } else {
          this.$message.warning('请选择节点')
          return
        }
      }
      _.forEach(this.currentCreateParams.documentDataList, (item) => {
        this.getDocumentFileList(item)
      })
    },
    // 获取查找文档关联文件
    async getDocumentFileList(data) {
      const res = await DocumentManagementService.getFileList({
        id: data.id,
      })
      if (res && res.data) {
        this.checkModel(res.data)
      }
    },
    /**
     * @description: 检查是否模型是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel(modelParams) {
      const currentModelFile = _.find(modelParams, (item) => {
        return item.fileType === '.pr' || item.fileType === '.fbx'
      })
      if (!currentModelFile) {
        this.$message.error('当前项目没有模型')
        return
      }
      const currentZip = _.find(modelParams, ['fileType', '.zip'])
      if (currentZip) {
        this.checkModelMaterial(currentZip, currentModelFile)
      } else {
        this.getCurrentModelFile(currentModelFile, {})
      }
    },

    // 检查模型材质文件
    async checkModelMaterial(item, modelParams) {
      // eslint-disable-next-line no-await-in-loop
      const result = await this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      const exists = await this.player.Native.File.exists(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      if (item.md5 === result && exists) {
        this.getCurrentModelFile(modelParams, item)
      } else {
        this.downloadMaterialFile(item.md5, item, modelParams)
      }
    },

    // 检查模型是否存在
    getCurrentModelFile(item, materialParams) {
      this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
        (res) => {
          if (res === item.md5) {
            // 有模型就加载模型
            this.addModel(
              item.md5,
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
              item,
              materialParams
            )
          } else {
            // 校验md5失败
            this.downloadFile(item.md5, item.fileType, item, materialParams)
          }
        }
      )
    },

    // 下载材质文件
    async downloadMaterialFile(md5, item, modelParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMaterialMsg(modelParams.md5, item, modelParams)
      )
      const res = await this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` }
      )
      // 代表创建下载任务成功
      if (res) {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      } else {
        this.$message.warning('下载材质文件失败')
      }
    },

    /**
     * @description: 下载模型
     * @param {*} playerName：模型名称
     * @param {*} type： 模型类型
     * @return {*}
     */
    async downloadFile(md5, type, item, materialParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMsg(md5, item, type, materialParams)
      )
      this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` },
        (res) => {
          // 代表创建下载任务成功
          if (res) {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          } else {
            this.$message.warning('下载模型失败')
          }
        }
      )
    },
    // 监听下载模型是否成功
    downloadMsg(md5, item, type, materialParams) {
      const that = this
      const fun = async (file, err) => {
        that.loadPercentage = 0
        that.showLoadProgress = false
        if (err) {
          that.$message.warning(`下载文件失败，${file}, ${err}`)
          return
        }
        if (
          file ===
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          // 检查当前md5和远程下载的md5是否一致
          that.player.Native.File.getFileMd5(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
            (res) => {
              if (res !== md5) {
                that.$message.warning('当前请求的md5和服务器下载的md5不一致！')
              }
            }
          )
          that.addModel(md5, file, item, materialParams) // 模型下载成功就加载模型
        }
      }
      return fun
    },

    // 监听下载模型是否成功
    downloadMaterialMsg(md5, item, modelParams) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载材质文件失败，${file}, ${err}`)
          return
        }
        if (
          file === `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}.zip`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          await this.player.Native.UiQt.decompressingZIP(file, '')
          setTimeout(() => {
            that.getCurrentModelFile(modelParams, item)
          }, 1500)
        }
      }
      return fun
    },

    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    checkModelLoad(data) {
      this.loadType = '加载中...'
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd(data) {
      this.showLoadProgress = false
      this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 获取文档属性模板信息
    async getDocDetail(id) {
      const res = await DocumentManagementService.getDocumentEdite({
        id,
      })
      if (res && res.code === 0 && res.data) {
        if (!_.isEmpty(res.data.templateAttrSetList)) {
          const val = _.find(res.data.templateAttrSetList[0].attrValueList, (el) => {
            return el.fieldName === 'type'
          })
          return val ? val.attrValue : ''
        }
      }
      return ''
    },
    // 加载模型
    async addModel(md5, url, item, materialParams) {
      this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      const modelName = await this.getDocDetail(item.documentId)
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      const currentRoot = _.find(rootItems, (val) => {
        return val.code && JSON.parse(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const rootNode =
        !_.isNil(currentRoot) && currentRoot.nodePtr
          ? currentRoot.nodePtr
          : await this.player.Native.NodeProxy.rootNode()
      let parentNode =
        this.propsNodeData.nodePtr && this.isShowTags ? this.propsNodeData.nodePtr : rootNode
      if (this.currentCreateParams.modifyNode && this.currentCreateParams.modifyNode.nodePtr) {
        const editNode = await this.player.Native.NodeEditor.node()
        if (editNode === this.currentCreateParams.modifyNode.nodePtr) {
          await this.player.Native.NodeEditor.setNode(0)
        }
        await this.player.Native.NodeProxy.destroyNode(this.currentCreateParams.modifyNode.nodePtr)
        if (this.propsNodeData.nodePtr === this.currentCreateParams.modifyNode.nodePtr) {
          parentNode = this.propsNodeData.parentPtr
        }
      }
      let currentNode = null
      if (item.fileType === '.pr') {
        currentNode = await loadPrModel(
          url,
          this.currentCreateParams.name || item.documentName,
          parentNode,
          this.player
        ) // 加载模型
      } else if (item.fileType === '.fbx') {
        currentNode = await loadFbxModel(
          url,
          this.currentCreateParams.name || item.documentName,
          parentNode,
          this.player
        )
      } else {
        currentNode = await this.player.Native.NodeProxy.loadModelNode(
          parentNode,
          url,
          this.currentCreateParams.name || item.documentName
        ) // 加载模型
      }
      await this.player.Native.NodeProxy.setGlobalTranslation(currentNode, this.nodePosition)
      await this.player.Native.NodeProxy.setNodeInfo(currentNode, {
        code: JSON.stringify({
          type: this.currentCreateParams.type,
          fileType: item.fileType,
          filePath: url,
          documentId: item.documentId,
          documentName: item.documentName,
          documentCode: item.documentCode,
          md5,
          materialFileMd5: materialParams.md5,
          model: modelName,
          titleText: this.cabinetName,
        }),
      })
      const depthBoardFrontNode = await this.player.Native.NodeProxy.findFirstNodeByName(
        currentNode,
        'depthBoard_front'
      )
      if (depthBoardFrontNode) {
        await this.player.Native.NodeProxy.setNodeVisible(depthBoardFrontNode, false)
      }
      const depthBoardBackNode = await this.player.Native.NodeProxy.findFirstNodeByName(
        currentNode,
        'depthBoard_back'
      )
      if (depthBoardBackNode) {
        await this.player.Native.NodeProxy.setNodeVisible(depthBoardBackNode, false)
      }
      this.propsNodeData = await this.player.Native.NodeProxy.getNodeInfo(currentNode)
      this.drawTagInfo(
        currentNode,
        this.currentCreateParams.CabinetName || this.currentCreateParams.name || item.documentName,
        md5,
        'Title_Top',
        materialParams
      )
      this.$emit('updateEditTree', currentNode)
      this.currentNodeName = ''
      this.cabinetName = ''
    },
    // 绘制机柜标签
    async drawTagInfo(node, name, parentMd5, tagName, materialParams) {
      const tagInfo = _.find(this.tagDataList, ['name', tagName])
      const res = await DocumentManagementService.getFileList({
        id: tagInfo.id,
      })
      if (res && res.data) {
        this.currentTagFile = _.find(res.data, (item) => {
          return item.fileType === '.pr' || item.fileType === '.fbx'
        })
        if (this.currentTagFile) {
          const url = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.currentTagFile.md5}/${this.currentTagFile.md5}${this.currentTagFile.fileType}`
          const exists = await this.player.Native.File.exists(url)
          if (exists) {
            this.drawNodeMaterial(node, name, tagName, url, parentMd5, materialParams)
          } else {
            this.player.Native.File.EventDownloadFinish.connect(
              this.downloadTagMsg(node, name, tagName, parentMd5, materialParams)
            )
            this.player.Native.File.downloadFile(
              url,
              'GET',
              `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${this.currentTagFile.md5}`,
              { Authorization: `${this.fullToken}` }
            )
          }
        }
      }
    },
    // 监听标签文件下载完毕
    async downloadTagMsg(node, name, tagName, parentMd5, materialParams) {
      const that = this
      const fun = async (file, err) => {
        if (!err) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          setTimeout(() => {
            that.drawNodeMaterial(node, name, tagName, file, parentMd5, materialParams)
          }, 1500)
        }
      }
      return fun
    },
    // 绘制标签贴图
    async drawNodeMaterial(node, name, tagName, file, parentMd5, materialParams) {
      const guid = generateGUID()
      const url = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${parentMd5}/${guid}.png`
      const canvas = document.createElement('canvas')
      canvas.width = 500
      canvas.height = 50
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.font = 'bold 28px arial'
      ctx.textAlign = 'center'
      ctx.fillStyle = '#ff0000'
      ctx.fillText(name, 250, 30)
      const imgUrl = canvas.toDataURL('image/png')
      canvas.remove()
      await this.player.Native.File.downloadFile(url, 'GET', imgUrl, {}, async (res) => {
        this.setNodeMaterial(node, name, tagName, file, parentMd5, url, guid, materialParams)
      })
    },
    //
    async setNodeMaterial(node, name, tagName, file, parentMd5, imgUrl, guid, materialParams) {
      const modelName = await this.getDocDetail(this.currentTagFile.documentId)
      // 加载标签
      const currentNode = await this.player.Native.NodeProxy.loadModelNode(node, file, tagName)
      // 获取父节点信息
      const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(node)
      // 获取标签信息
      const tagNodeInfo = await this.player.Native.NodeProxy.getNodeInfo(currentNode)
      // 获取父级包围盒
      const calcAabb = await this.player.Native.ModelTree.calcItemAabbData(nodeInfo.item)
      // 获取标签包围盒
      const tagAabb = await this.player.Native.ModelTree.calcItemAabbData(tagNodeInfo.item)
      const tagHeight = Math.abs(tagAabb.aabb[0][2] - tagAabb.aabb[1][2])
      const frontFaceCenter = Aabb.faceCenter(calcAabb.aabb, 'YN')
      await this.player.Native.NodeProxy.setGlobalTranslation(currentNode, [
        frontFaceCenter[0],
        frontFaceCenter[1],
        calcAabb.aabb[1][2] - tagHeight / 2,
      ])
      await this.player.Native.NodeProxy.setNodeInfo(currentNode, {
        code: JSON.stringify({
          type: 'CabinetTag',
          fileType: this.currentTagFile.fileType,
          filePath: file,
          documentId: this.currentTagFile.documentId,
          documentName: this.currentTagFile.documentName,
          documentCode: this.currentTagFile.documentCode,
          md5: this.currentTagFile.md5,
          materialFileMd5: materialParams.md5,
          model: modelName,
          tagInfo: {
            text: name,
            id: guid,
            file: `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${parentMd5}/${guid}.png`,
          },
        }),
      })
      const childNode = await this.player.Native.NodeProxy.getNodeChildren(currentNode)
      const materialPtr = await this.player.Native.NodeProxy.getNodeMaterial(childNode[0].nodePtr)
      if (materialPtr) {
        const copyMaterial = await this.player.Native.NodeProxy.copyMaterial(materialPtr)
        await this.player.Native.NodeProxy.setNodeMaterial(childNode[0].nodePtr, copyMaterial)
        await this.player.Native.NodeProxy.setMaterialTexture(copyMaterial, imgUrl)
      }
    },
    // 获取机柜的文件路径id
    async getFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '机柜',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '机柜'
          })
          if (currentFolder) {
            this.defaultFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取属性模板
    async getAttributeTemplateList() {
      const res = await DocumentManagementService.getTemplateByClassId({
        classId: this.DevicesClassId,
      })
      if (res && res.code === 0 && res.data) {
        if (res.data.templateAttrSetList) {
          this.templateAttrSetList = _.cloneDeep(res.data.templateAttrSetList)
        }
      }
    },
    // 加载模型节点
    async loadCabinetNode() {
      const isSelectList = _.filter(this.deviceList, ['select', true])
      const params = {
        modifyNode: this.isShowTags ? this.propsNodeData : '',
        documentDataList: isSelectList,
        type: 'Cabinet',
        name: this.currentNodeName,
        CabinetName: this.cabinetName,
        positionType: this.addTypeValue === 1 ? 'anchor' : 'faceCenter',
        faceValue: this.nodePositionValue,
      }
      this.createNode(params)
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
    },
    // 获取机柜列表
    async getDataList() {
      if (this.defaultFolderId) {
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: this.defaultFolderId,
          isRecursion: true,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
          keyWord: this.searchTypeKey,
        }
        // // 拼接属性模板搜索条件
        // if (this.templateAttrSetList) {
        //   const attrValue = _.find(this.templateAttrSetList[0].attrValueList, (item) => {
        //     return item.attrbuteDetail.displayName === '型号'
        //   })
        //   query.searchItems = [
        //     {
        //       tableName: this.templateAttrSetList[0].tableName,
        //       tableItems: [
        //         {
        //           fieldName: attrValue.fieldName,
        //           fieldValue: this.searchTypeKey,
        //           valueType: attrValue.valueType,
        //         },
        //       ],
        //     },
        //   ]
        // }
        const res = await DocumentManagementService.advancedSearch(query)
        if (res && res.code === 0 && res.data) {
          this.deviceList = _.map(res.data.items, (item) => {
            return {
              ...item,
              select: false,
            }
          })
        }
      }
    },
    // 取消编辑
    cancleModify() {
      this.currentNodeName = ''
      this.cabinetName = ''
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      this.$emit('cancleModify')
    },
    // 二次设备编辑
    editDevice() {
      this.currentNodeName = this.propsNodeData.name
      this.cabinetName =
        isJSONObj(this.propsNodeData.code) && JSON.parse(this.propsNodeData.code)
          ? JSON.parse(this.propsNodeData.code).titleText
          : this.propsNodeData.name
      _.forEach(this.deviceList, (item) => {
        if (
          isJSONObj(this.propsNodeData.code) &&
          item.id === JSON.parse(this.propsNodeData.code).documentId
        ) {
          item.select = true
        }
      })
      this.$emit('getTags', true)
    },
    // 选择模型切换
    selectChange(data) {
      this.currentNodeName = data.name
      this.cabinetName = data.name
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      data.select = true
    },
    search() {
      this.getDataList()
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../../css/index.scss';
@import '../../../css/select.scss';
.list {
  background: rgba(24, 41, 72, 0.5) !important;
}
/deep/.player_progress {
  position: fixed !important;
}
/deep/.el-checkbox__label {
  font-size: 12px !important;
  max-width: 80px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list_content {
  flex-wrap: wrap;
  p {
    line-height: 34px;
    width: 90px;
    text-align: center;
  }
  /deep/ .el-input {
    width: 320px !important;
    height: 32px;
  }
  /deep/.el-input__inner {
    width: 320px !important;
    height: 32px;
  }
}
.create_new {
  z-index: 999;
  position: absolute;
  bottom: 7px;
  right: 20px;
}
.Cabinet_top {
  background-color: rgba(24, 41, 72, 0.5);
}

.Cabinet_bottom {
  width: 100%;
  height: calc(100% - 174px);
  background-color: rgba(24, 41, 72, 0.5);
  margin-top: 10px;
  padding: 5px;
  overflow-y: auto;
}
.Cabinet_model {
  .model-item {
    height: 160px;
    .item-img {
      height: calc(100% - 30px);
      background-color: #383b3b !important;
    }
    .item-title {
      height: 30px;
      line-height: 30px;
    }
  }
  .model-item:hover {
    background-color: rgba(46, 107, 176, 0.5) !important;
  }
  .Cabinet_model_card {
    height: 140px;
    width: 85px;
    margin: 0 20px 30px 0;
    img {
      margin: 0 8px;
      width: 70px;
      height: 110px;
      background-color: crimson;
    }
    p {
      width: 100%;
      text-align: center;
      line-height: 20px;
      height: 20px;
    }
  }
}
.card-footer {
  border: none !important;
}

</style>
